import styled from './AppNotification.scss';

export const TRANSITION_CLASSES = {
  appear: styled.transitionEnter,
  appearActive: styled.transitionEnterActive,
  enter: styled.transitionEnter,
  enterActive: styled.transitionEnterActive,
  exit: styled.transitionExit,
  exitActive: styled.transitionExitActive,
};

export const NOTIFICATION_DELAY_CLOSE = 5000;
